export var TipoDocDominioEnum;
(function (TipoDocDominioEnum) {
    TipoDocDominioEnum["MATRICULA_ATUALIZADA"] = "MATRICULA_ATUALIZADA";
    TipoDocDominioEnum["ESCRITURA_PUBLICA_AQUISICAO"] = "ESCRITURA_PUBLICA_AQUISICAO";
    TipoDocDominioEnum["CONTRATO_ARRENDAMENTO_COMODATO_PARCERIA"] = "CONTRATO_ARRENDAMENTO_COMODATO_PARCERIA";
    TipoDocDominioEnum["DOC_COMPROV_COND_POSSE"] = "DOC_COMPROV_COND_POSSE";
    TipoDocDominioEnum["DECLARACAO_FIRMADA_EMPAER_OU_EXEC_PUB_MUNI"] = "DECLARACAO_FIRMADA_EMPAER_OU_EXEC_PUB_MUNI";
})(TipoDocDominioEnum || (TipoDocDominioEnum = {}));
(function (TipoDocDominioEnum) {
    var mapDescricao = new Map([
        [TipoDocDominioEnum.MATRICULA_ATUALIZADA, 'Matrícula Atualizada'],
        [TipoDocDominioEnum.ESCRITURA_PUBLICA_AQUISICAO, 'Escritura Pública de Aquisição'],
        [TipoDocDominioEnum.CONTRATO_ARRENDAMENTO_COMODATO_PARCERIA, 'Contrato de Arrendamento, Comodato ou Parceria'],
        [TipoDocDominioEnum.DOC_COMPROV_COND_POSSE, 'Documento que Comprove a Condição de Posse'],
        [TipoDocDominioEnum.DECLARACAO_FIRMADA_EMPAER_OU_EXEC_PUB_MUNI, 'Declaração firmada pela EMPAER ou Gestor do Poder Executivo Público Municipal'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoDocDominioEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoDocDominioEnum.getOptions = getOptions;
})(TipoDocDominioEnum || (TipoDocDominioEnum = {}));
